import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DeleteSvg, EditSvg, SwitchOffSvg, SwitchOnSvg } from "../../../assets/svg/index.js";
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { api_urls } from "../../../utils/api-urls/index.js";
import MainDatatable from "../../../components/common/MainDatatable.jsx";
import * as SancharActions from '../../../redux/actions/sancharAction';

const News = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { newsData } = useSelector(state => state.sancharReducer);

    //* DataTable Columns
    const columns = [
        { name: 'S.No.', selector: row => newsData?.length - newsData.indexOf(row), style: { backGroundColor: "#000", paddingLeft: "20px" } },
        { name: 'Category', selector: row => row?.newsCategoryId?.category_name },
        { name: 'Sub Category', selector: row => row?.newsubCategoryId?.sub_category_name },
        { name: 'Author', selector: row => row?.author },
        { name: 'News', selector: row => row?.title },
        { name: 'Description', selector: row => <div dangerouslySetInnerHTML={{ __html: row?.details }}></div> },
        { name: 'Breaking News', selector: row => row?.breaking_news ? 'Yes' : 'No' },
        { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        { name: 'Status', selector: row => <div onClick={() => dispatch(SancharActions.changeNewsStatus({ newsId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/news/edit-news', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                <div onClick={() => dispatch(SancharActions.deleteNews({ newsId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
            </div>,
            width: "180px"
        },
    ];

    useEffect(() => {
        //! Dispatching API for Getting news
        dispatch(SancharActions.getNews())
    }, []);

    return (
        <>
            <MainDatatable data={newsData} columns={columns} title={'News'} url={'/news/add-news'} />

        </>
    );
};

export default News;